export default __webpack_public_path__ + "locales/pt-BR/InviteDialog.json?hash=ac994a29dbfa156579d04cb9c9f3f946";